import { HER_ACTIONS } from "../../actions/herActions";
import { HER_MODULE_EVENT } from "../../constants/common";

const herReducer = (state = {
  modulesLoaded: [],
  modulesToBeLoaded: [],
  herEvent: ''
}, action) => {
  switch (action.type) {
    case HER_ACTIONS.ON_MODULE_LOAD:
      let modulesLoaded = state.modulesLoaded;
      modulesLoaded.push(action.payload);
      state = {
        ...state,
        modulesLoaded: modulesLoaded,
        herEvent: HER_MODULE_EVENT.MODULE_LOADED
      }
      break;
    case HER_ACTIONS.ON_MODULE_UNLOAD:
      let existingModules = state.modulesLoaded;
      let moduleIndex = existingModules.indexOf(action.payload);
      existingModules.splice(moduleIndex, 1);
      state = {
        ...state,
        modulesLoaded: existingModules
      }
      break;
    case HER_ACTIONS.SET_HER_MODULES:
      state = {
        ...state,
        modulesToBeLoaded: action.payload,
        herEvent: HER_MODULE_EVENT.MODULES_TO_BE_LOADED
      }
      break;
    default:
      break;
  }
  return state;
};

export default herReducer;
